import DetalhesRepasses from './detalhesRepasses';

export default DetalhesRepasses;
